import React from "react";
import "./MapLocation.css";

function MapLocation({ location }) {
  return (
    <div className="map-location col-12 my-4">
      <h2>İlan Konumu</h2>
      <iframe
        src={location}
        width="100%"
        height="100%"
        allowFullScreen=""
        loading="lazy"
        title="Google Maps Konumu"
      ></iframe>
    </div>
  );
}

export default MapLocation;
